export function getSlugsByLocale(translations, languageMap = {}) {
  const map = {}
  if (!translations?.length) return map
  translations.forEach(t => {
    const iso = t.locale || t.language?.iso || languageMap[t.language_id]
    if (iso && t.slug) {
      map[iso] = t.slug
    }
  })
  return map
}

export function resolveLocaleSlug(
  slugs,
  code,
  { currentLocale, currentSlug, defaultLocale = 'fr' }
) {
  if (slugs[code]) return slugs[code]
  if (slugs[defaultLocale]) return slugs[defaultLocale]
  return currentLocale === defaultLocale ? currentSlug || null : null
}

export function computeAlternateUrls({
  locales,
  localePath,
  routeName,
  buildParams,
  store,
}) {
  const alternateUrls = {}
  locales.forEach(locale => {
    const params = buildParams(locale.code)
    if (!params) return
    alternateUrls[locale.code] = localePath(
      { name: routeName, params },
      locale.code
    )
  })
  if (store) {
    store.commit('SET_ALTERNATE_URLS', alternateUrls)
  }
  return alternateUrls
}

export function buildHreflangLinks({
  locales,
  configUrl,
  localePath,
  routeName,
  buildParams,
  defaultLocale = 'fr',
  store,
}) {
  const alternateUrls = computeAlternateUrls({
    locales,
    localePath,
    routeName,
    buildParams,
    store,
  })
  const links = []

  locales.forEach(locale => {
    const path = alternateUrls[locale.code]
    if (!path) return
    links.push({
      hid: `i18n-alt-${locale.code}`,
      rel: 'alternate',
      href: configUrl + path,
      hreflang: locale.code,
    })
  })

  const defaultParams = buildParams(defaultLocale)
  if (defaultParams) {
    links.push({
      hid: 'i18n-xd',
      rel: 'alternate',
      href:
        configUrl +
        localePath({ name: routeName, params: defaultParams }, defaultLocale),
      hreflang: 'x-default',
    })
  }

  return links
}

export function entitySlugForLocale(vm, entity, code) {
  return resolveLocaleSlug(
    getSlugsByLocale(entity?.translations, vm.languageMap),
    code,
    { currentLocale: vm.$i18n.locale, currentSlug: entity?.slug }
  )
}

export function remapI18nAlternates(links, locales) {
  const overrides = {}
  locales.forEach(locale => {
    const language = (locale.iso || '').split('-')[0]
    if (language && language !== locale.code) {
      overrides[language] = locale.code
    }
  })
  return links.map(link => {
    const code = link.rel === 'alternate' && overrides[link.hreflang]
    return code ? { ...link, hreflang: code, hid: `i18n-alt-${code}` } : link
  })
}
